import { useSelector, shallowEqual } from 'react-redux';

import { useMeterType } from 'hooks/useMeterType';
import { selectFuelType } from 'state/fuel-type/fuel-type-slice';
import { useHasInitialState } from 'components/direct-sales/personalise-quote/hooks/useHasInitialState';
import { useEligibleFuel } from 'hooks/useEligibleFuel';
import { allTrue } from 'utils/misc';

export const useHasMixedMeters = () => {
  const { fuel: hasFuelInitialState } = useHasInitialState();
  const eligibleFuels = useEligibleFuel();

  const {
    hasGasPrepayMeter,
    hasElectricityPrepayMeter,
    isElecPrepayMeter,
    isGasPrepayMeter
  } = useMeterType();

  const fuelType = useSelector(selectFuelType, shallowEqual);
  const isDualFuel = fuelType.electric && fuelType.gas;

  if (!allTrue(eligibleFuels)) {
    return false;
  }

  if (hasFuelInitialState) {
    return (
      (isElecPrepayMeter && !isGasPrepayMeter) ||
      (!isElecPrepayMeter && isGasPrepayMeter)
    );
  }

  return (
    isDualFuel &&
    ((hasElectricityPrepayMeter && !hasGasPrepayMeter) ||
      (!hasElectricityPrepayMeter && hasGasPrepayMeter))
  );
};
